export const MONTH_NAMES = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export const DAY_NAMES = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

export const DAY_SHORT_NAMES = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

/** Parses "YYYY-MM-DD HH:mm:ss" as local time (older Safari versions reject the space separator). */
export const parseLocalDateTime = (value: string) => new Date(value.replace(' ', 'T'));

export const formatTime = (date: Date) => `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;

export const formatDate = (date: Date) => date.toLocaleDateString('de-AT');
